import styled from 'styled-components';
import { Card, Text } from '@perch-labs/shrike';

export const StyledCard = styled(Card)`
  overflow: hidden;
`;

export const CardContent = styled(Card.Content)`
  padding-bottom: 0;
`;

export const Amount = styled(Text)<StyleProps>`
  color: ${props =>
    props.isCredit
      ? props.theme.colors.content.accent9
      : props.theme.colors.content.primary};
`;
